module.exports = __webpack_public_path__ + "img/DlshadRawand-SawrkawtnDwayShkst.4ccdc012.jpg";